import {Base} from "@/api/Base"

export class RoleDelete extends Base {
    path = "role/delete"
}